
//LIVE CONFIG
export const RAZORPAY_KEY_ID = "rzp_live_S0CCKBUG6HaT2e";
export const RAZORPAY_SECRET_KEY_ID = "iClB7NoRd8CdVdEY5y6688s3";

//TEST CONFIG
// export const RAZORPAY_KEY_ID = "rzp_test_S2SvPeF9cdb6JN";
// export const RAZORPAY_SECRET_KEY_ID = "77k7pzA1MaTbHEKs09dV9RNM";
